export const dataHooks = {
    socialIcon: 'social-button-icon',
    socialTitle: 'social-button-title',
};
export const icons = [
    'facebook',
    'instagram',
    'twitter',
    'linkedin',
    'pinterest',
    'youtube',
    'xcorp',
];
//# sourceMappingURL=constants.js.map